import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Usuń", -1)

import { UiButton } from '@/components/common/ui'
import { IPropsTheButton } from '@/components/common/ui/UiButton.vue'
interface Props extends IPropsTheButton {
    none?: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    none: { type: Boolean, required: false }
  },
  setup(__props: any) {

const props = __props as {
    none?: boolean
}


return (_ctx: any,_cache: any) => {
  const _component_IconCross = _resolveComponent("IconCross")!

  return (_openBlock(), _createBlock(_unref(UiButton), _normalizeProps(_guardReactiveProps(props)), {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_IconCross, { style: {"transform":"rotate(45deg)"} })
    ]),
    _: 1
  }, 16))
}
}

})